import axios from 'axios';

const UNSPLASH_API_KEY = process.env.REACT_APP_UNSPLASH_API_KEY;

const unsplash = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization: `Client-ID ${UNSPLASH_API_KEY}`,
  },
});

export class ImageService {
  static async fetchRandomImage(category: string, forceRefresh = false): Promise<string | null> {
    if (!UNSPLASH_API_KEY) {
      console.error('Unsplash API key is not configured.');
      return 'https://images.unsplash.com/photo-1588420343618-6141b3aaa92b?q=80&w=2487&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';
    }

    const cacheKey = `unsplash_${category}`;
    const cachedItem = localStorage.getItem(cacheKey);
    const now = new Date().getTime();
    const
      CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

    if (cachedItem && !forceRefresh) {
      const { timestamp, imageUrl } = JSON.parse(cachedItem);
      if (now - timestamp < CACHE_DURATION) {
        return imageUrl;
      }
    }

    try {
      const response = await unsplash.get('/photos/random', {
        params: {
          query: category,
          count: 1,
        },
      });
      
      const imageUrl = response.data[0]?.urls?.regular;

      if (imageUrl) {
        const cacheData = { timestamp: now, imageUrl };
        localStorage.setItem(cacheKey, JSON.stringify(cacheData));
        return imageUrl;
      }
      
      return null;

    } catch (error) {
      console.error('Error fetching image from Unsplash:', error);
      // Fallback to cached version if API fails but cache exists
      if (cachedItem) {
        return JSON.parse(cachedItem).imageUrl;
      }
      return null;
    }
  }
}